"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var getPromoDiscount = function getPromoDiscount() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$products = _ref.products,
      products = _ref$products === void 0 ? [] : _ref$products,
      promo = _ref.promo;

  var promoDiscount = 0;

  if (promo) {
    var totalPrice = products.reduce(function (total, p) {
      return total + (p.quantity || 0) * (p.price || 0);
    }, 0);
    var amount = promo.amount || 0;
    promoDiscount = totalPrice - amount;
    if (promoDiscount < 0) promoDiscount = 0;
  }

  return Number(Math.round(promoDiscount + 'e2') + 'e-2');
};

var _default = getPromoDiscount;
exports["default"] = _default;